/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import CaddForms from '../../../../../components/Forms/due-diligence/index';


function DueDiligence() {
  return <CaddForms module="cadd" />;
}


export default DueDiligence;